class BackToTop extends HTMLElement {
  constructor() {
    super();

    let stickyAdd = document.querySelector('sticky-add');
    if (stickyAdd) return;

    this.listeners();
  }

  listeners() {

    this.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
    
    window.addEventListener('scroll', debounce(this.scrollCheck, 300));
  }

  scrollCheck() {

    let backToTop = document.querySelector('back-to-top');

    return (window.pageYOffset > 100 ? backToTop.classList.add('show') : backToTop.classList.remove('show'));    
  }

}

customElements.define('back-to-top', BackToTop);